import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Form, Input, Button, Upload, message, Select } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { API_URL as PRODUCTO_API_URL } from '../../apis/apiProductos';
import { API_URL as IMAGEN_PRODUCTO_API_URL } from '../../apis/apiImagenProducto';
import { API_URL as CATEGORIA_API_URL } from '../../apis/apiCategorias';
import { API_URL as MARCA_API_URL } from '../../apis/apiMarcas';
import { API_URL as ESTADO_API_URL } from '../../apis/apiEstados';

const CrearProducto = () => {
    const [formData, setFormData] = useState({
        modelo: '',
        nombre: '',
        descripcion: '',
        estado: 1,  // Estado por defecto con id 1
        categoria: null,
        marca: null,
    });

    const [categorias, setCategorias] = useState([]);
    const [estados, setEstados] = useState([]);
    const [marcas, setMarcas] = useState([]);
    const [fileList, setFileList] = useState([]);

    useEffect(() => {
        const fetchCategorias = async () => {
            try {
                const response = await axios.get(CATEGORIA_API_URL);
                setCategorias(response.data);
            } catch (error) {
                console.error('Error al obtener categorías:', error);
                message.error('Hubo un error al cargar las categorías');
            }
        };

        const fetchEstados = async () => {
            try {
                const response = await axios.get(ESTADO_API_URL);
                setEstados(response.data);
            } catch (error) {
                console.error('Error al obtener estados:', error);
                message.error('Hubo un error al cargar los estados');
            }
        };

        const fetchMarcas = async () => {
            try {
                const response = await axios.get(MARCA_API_URL);
                setMarcas(response.data);
            } catch (error) {
                console.error('Error al obtener marcas:', error);
                message.error('Hubo un error al cargar las marcas');
            }
        };

        fetchCategorias();
        fetchEstados();
        fetchMarcas();
    }, []);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleImagesChange = ({ fileList: newFileList }) => {
        setFileList(newFileList);
    };

    const handleRemoveImage = (file) => {
        setFileList((prev) => prev.filter((item) => item.uid !== file.uid));
        message.success('Imagen eliminada');
    };

    const handleSubmit = () => {
        // Validar formulario
        if (!formData.modelo || !formData.nombre || !formData.descripcion) {
            message.error('Por favor, complete todos los campos requeridos.');
            return;
        }

        if (!formData.categoria) {
            message.error('Por favor, seleccione una categoría.');
            return;
        }

        if (!formData.marca) {
            message.error('Por favor, seleccione una marca.');
            return;
        }

        if (!formData.estado) {
            message.error('Por favor, seleccione un estado.');
            return;
        }

        if (fileList.length === 0) {
            message.error('Por favor, suba al menos una imagen.');
            return;
        }

        const productoData = new FormData();
        productoData.append('modelo', formData.modelo);
        productoData.append('nombre', formData.nombre);
        productoData.append('descripcion', formData.descripcion);
        productoData.append('estado', formData.estado);
        productoData.append('categoria', formData.categoria);
        productoData.append('marca', formData.marca);

        axios.post(PRODUCTO_API_URL, productoData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
        .then((response) => {
            const productoId = response.data.id;
            message.success('Producto creado con éxito');

            // Subir imágenes solo si hay imágenes
            if (fileList.length > 0) {
                fileList.forEach((file) => {
                    const imagenData = new FormData();
                    imagenData.append('producto', productoId);
                    imagenData.append('imagen', file.originFileObj);

                    axios.post(IMAGEN_PRODUCTO_API_URL, imagenData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    })
                    .then(() => {
                        message.success('Imágenes subidas con éxito');
                    })
                    .catch((error) => {
                        console.error('Error al subir imágenes:', error);
                        message.error('Error al subir las imágenes');
                    });
                });
            }

            // Reiniciar el formulario
            setFormData({
                modelo: '',
                nombre: '',
                descripcion: '',
                estado: 1,
                categoria: null,
                marca: null,
            });
            setFileList([]);  // Reiniciar el fileList
        })
        .catch((error) => {
            console.error('Error al crear producto:', error);
            message.error('Hubo un error al crear el producto');
        });
    };

    return (
        <div style={{ maxWidth: '800px', margin: '0 auto', padding: '20px', backgroundColor: '#f0f2f5', borderRadius: '8px', boxShadow: '0 4px 8px rgba(0.2, 0.2, 0.2, 0.2)', marginTop: '15px', marginBottom: '15px' }}>
            <h2 style={{ textAlign: 'center', color: '#001529', marginBottom: '24px' }}>Crear Producto</h2>
            <Form layout="vertical" onFinish={handleSubmit}>
                <Form.Item label="Modelo" required>
                    <Input
                        type="text"
                        name="modelo"
                        value={formData.modelo}
                        onChange={handleChange}
                        required
                    />
                </Form.Item>
                <Form.Item label="Nombre del Producto" required>
                    <Input
                        type="text"
                        name="nombre"
                        value={formData.nombre}
                        onChange={handleChange}
                        required
                    />
                </Form.Item>
                <Form.Item label="Descripción" required>
                    <Input.TextArea
                        name="descripcion"
                        value={formData.descripcion}
                        onChange={handleChange}
                        required
                        rows={4}
                    />
                </Form.Item>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ width: '48%' }}>
                        <Form.Item label="Categoría" required>
                            <Select
                                name="categoria"
                                value={formData.categoria}
                                onChange={(value) => setFormData({ ...formData, categoria: value })}
                                placeholder="Selecciona una categoría"
                                required
                            >
                                {categorias.map(categoria => (
                                    <Select.Option key={categoria.id} value={categoria.id}>
                                        {categoria.nombre}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </div>
                    <div style={{ width: '48%' }}>
                        <Form.Item label="Marca" required>
                            <Select
                                name="marca"
                                value={formData.marca}
                                onChange={(value) => setFormData({ ...formData, marca: value })}
                                placeholder="Selecciona una marca"
                                required
                            >
                                {marcas.map(marca => (
                                    <Select.Option key={marca.id} value={marca.id}>
                                        {marca.nombre}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </div>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div style={{ width: '48%' }}>
                        <Form.Item label="Estado" required>
                            <Select
                                name="estado"
                                value={formData.estado}
                                onChange={(value) => setFormData({ ...formData, estado: value })}
                                placeholder="Selecciona un estado"
                                required
                            >
                                {estados.map(estado => (
                                    <Select.Option key={estado.id} value={estado.id}>
                                        {estado.descripcion}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </div>
                    <div style={{ width: '48%' }}>
                        <Form.Item label="Imágenes del Producto" required>
                            <Upload
                                accept="image/*"
                                multiple
                                fileList={fileList}  // Usar fileList aquí
                                onChange={handleImagesChange}
                                onRemove={handleRemoveImage}  // Función para eliminar imágenes
                                beforeUpload={(file) => false} // Para evitar la subida automática
                                showUploadList={{
                                    showRemoveIcon: true,
                                    showPreviewIcon: false,
                                }}
                            >
                                <Button icon={<UploadOutlined />}>Seleccionar Imágenes</Button>
                            </Upload>
                        </Form.Item>
                    </div>
                </div>
                <Form.Item>
                    <Button type="primary" htmlType="submit" block>
                        Crear Producto
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
};

export default CrearProducto;
